import Vue from "vue"
import App from "./App.vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "element-ui/lib/theme-chalk/display.css"
import VueRouter from "vue-router"
import Vuex from "vuex"
import store from "../src/store"


import home from "../src/components/home"
import prepare from "../src/components/prepare"
import prepare2 from "../src/components/prepare2"
import prepare3 from "../src/components/prepare3"
import page1_1 from "../src/components/page1-1"
import page1_2 from "../src/components/page1-2"
import page2 from "../src/components/page2"
import page3 from "../src/components/page3"
import page4 from "../src/components/page4"
import page5 from "../src/components/page5"

import axios from "axios"
import VueAxios from "vue-axios"
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueAxios, axios)


const routes = [
	{
		path: "/",
		component: home,
		redirect: "prepare",
		children: [
			{ path: "prepare", component: prepare },
			{ path: "prepare2", component: prepare2 },
			{ path: "prepare3", component: prepare3 },
			{ path: "part1-1", component: page1_1 },
			{ path: "part1-2", component: page1_2 },
			{ path: "part2", component: page2 },
			{ path: "part3", component: page3 },
			{ path: "part4", component: page4 },
			{ path: "part5", component: page5 },
			// { path: "artapply", component: ArtApplication },
			// { path: "techapply", component: TechApplication },
			// { path: "applies", component: ShowApplication },
			// { path: "forms", component: QueryManage },
			// { path: "pictures", component: Picture }
		]
	}
]

const router = new VueRouter({
	routes
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app")
